import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  private currentPrintSource = new BehaviorSubject<string>("");
  currentPrint = this.currentPrintSource.asObservable();

  constructor() { }

  print(label: string) {
    this.currentPrintSource.next(label);
    setTimeout(() => {
      window.print();
    }, 0);
  }

}
